"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tile_1 = require("./tile");
const area_1 = require("./area");
const vector_1 = require("../core/vector");
class World extends area_1.Area {
    constructor(data, tileSize, diagonalMovementCost) {
        const grid = [];
        data.forEach((row, j) => {
            let tiles = grid[j] = [];
            row.forEach((value, i) => {
                tiles[i] = new tile_1.default(new vector_1.default(i, j), tileSize, value, diagonalMovementCost);
            });
        });
        super(grid);
        this.tileSize = tileSize;
        this.forEach(tile => tile.setWorld(this));
    }
}
exports.World = World;



//////////////////
// WEBPACK FOOTER
// ./src/world/world.ts
// module id = 7
// module chunks = 0